import styled from "styled-components";

export const Table = styled.table`
  border: 1px solid #e6e6e6;
  border-collapse: collapse;
`;
Table.displayName = "Table";

export default Table;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Table/Table.js